import type { TFunction } from '@/tools/i18n'
import { PasswordStrength } from '@/user/constants'

export const passwordStrengthMessages: Record<PasswordStrength, string> = {
  [PasswordStrength.EMPTY_PASSWORD]: 'common.password.length',
  [PasswordStrength.SHORT_PASSWORD]: 'common.password.length',
  [PasswordStrength.WEAK_PASSWORD]: 'password_recovery.weak.lable',
  [PasswordStrength.DECENT_PASSWORD]: 'password_recovery.decent',
  [PasswordStrength.STRONG_PASSWORD]: 'password_recovery.strong',
  [PasswordStrength.STRONGEST_PASSWORD]: 'password_recovery.strongest',
}

export const getInputErrorMessage = (
  validationError: string | null,
  passwordStrength: PasswordStrength | null,
  t: TFunction
) => {
  if (validationError) {
    return validationError
  } else if (passwordStrength === PasswordStrength.WEAK_PASSWORD) {
    return `${t('password.strength')} ${t(passwordStrengthMessages.WEAK_PASSWORD)}`
  } else {
    return null
  }
}

export const getInputInfoMessage = (
  validationError: string | null,
  passwordStrength: PasswordStrength | null,
  t: TFunction
) => {
  if (!passwordStrength || validationError || passwordStrength === PasswordStrength.WEAK_PASSWORD) {
    return null
  } else if (passwordStrength === PasswordStrength.EMPTY_PASSWORD) {
    return `${t('common.password.length')}`
  } else if (passwordStrength === PasswordStrength.SHORT_PASSWORD) {
    return `${t('common.password.length')}: ${t('password_recovery.weak.lable')}`
  } else {
    return `${t('password.strength')} ${t(passwordStrengthMessages[passwordStrength])}`
  }
}
